import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { activateUser } from '../utils/apiCalls';

export default function Welcome() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    // get Token from URL
    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setError('Invalid or missing activation token, please contact your administrator');
            return;
        }
        setToken(token);
    }, [searchParams]);


    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        try {
            await activateUser(token, password);
            setMessage('Your account has been activated!');

            setTimeout(() => {
                navigate('/login');
            }, 2000)
        } catch (error) {
            setError(error.message);
        }
        setLoading(false);
    }

    return(
        <div className='min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100'>

            {/* welcome card  */}
            <div className='flex items-center justify-center px-6 py-24'>
                <div className='w-full max-w-md p-10 rounded-xl shadow-2xl bg-white/90 backdrop-blur-md'>
                    <h3 className='text-3xl font-bold text-docpgrPurple mb-2 text-center'>welcome to invoco</h3>
                    <p className='text-sm text-gray-500 mb-6 text-center mb-6'>set your password to complete your account setup</p>

                    {error && <p className='mb-4 text-red-600 text-center bg-red-50 p-2 rounded'>{error}</p>}
                    {message && <p className='mb-4 text-green-600 text-center bg-green-50 p-2 rounded'> {message}</p>}

                    {!message && (
                        <form onSubmit={handleSubmit} className='space-y-5'>
                            <div>
                                <label className='block text-sm font-medium text-gray-700 mb-1'>new password</label>
                                <input type='password' required value={password} onChange={(event) => setPassword(event.target.value)} className='w-full px-4 py-2 border rounded-md focus:ring-docpgrPurple60 focus:border-docpgrPurple60 border-gray-300' placeholder='enter a strong password' />
                            </div>

                            <button type='submit' disabled={loading || error} className='w-full py-3 px-6 rounded-lg text-white font-bold voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition hover:bg-docpgrPurple70 focus:ring-4 focus:ring-docpgrPurple60 disabled:bg-docpgrPurple60 transition'>
                                {loading ? "activating..." : "activate account"}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    )
}